import { NavLink } from 'react-router-dom'
import { Mail, CalendarDays, ListTodo } from 'lucide-react'
import { NAV, EVENTS_NAV, ESSENCE } from '@/lib/nav'
import { openM365 } from '@/lib/m365'
import { DataFreshness } from './DataFreshness'
import { useHasPermission } from '@/store/useStore'

export function LeftRail({ open, onClose }: { open: boolean; onClose: () => void }) {
  const canManageEvents = useHasPermission('crm.events.manage')
  return (
    <aside className={`rail${open ? ' open' : ''}`}>
      <nav className="rail-nav">
        {NAV.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `rail-link${isActive ? ' active' : ''}`}
              onClick={onClose}
            >
              <Icon size={18} className="rail-link-icon" />
              <span className="rail-link-label">{item.label}</span>
            </NavLink>
          )
        })}
      </nav>

      {canManageEvents && (
        <div className="rail-events">
          <div className="rail-section-label label">Events</div>
          {EVENTS_NAV.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `rail-link${isActive ? ' active' : ''}`}
                onClick={onClose}
              >
                <Icon size={18} className="rail-link-icon" />
                <span className="rail-link-label">{item.label}</span>
              </NavLink>
            )
          })}
        </div>
      )}

      <DataFreshness />

      <div className="rail-m365">
        <div className="rail-section-label label">Microsoft 365</div>
        <button className="rail-m365-btn" onClick={() => openM365('email')}><Mail size={15} /><span>Email</span></button>
        <button className="rail-m365-btn" onClick={() => openM365('calendar')}><CalendarDays size={15} /><span>Calendar</span></button>
        <button className="rail-m365-btn" onClick={() => openM365('planner')}><ListTodo size={15} /><span>Planner</span></button>
      </div>

      <div className="rail-essence">{ESSENCE}</div>
    </aside>
  )
}
